import React from 'react';

export default function UserManagement() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">User Management</h1>
      <p className="text-gray-500">Halaman User Management</p>
    </div>
  );
}
